<template>
    <div id="infoHeaderRoot">
        <!-- Header -->
        <div @click="toggleBodyScroll(!infoClick)" id="headerContainer">

            <!-- Left -->
            <div id="contentTitle">
                <span>Information</span>
            </div>

            <!-- Chevron -->
            <div id="arrow">
                <img v-bind:class="infoArrow" src="../assets/chevron-down.svg"/>
            </div>
        </div>

        <!-- Content container -->
        <div v-bind:class="panelContent">
            <div id="contentDescriptionContainer">
                <!-- Actual Content -->
                <div id="content">
                    <p v-html="information"></p>
                </div>

                <!-- Close Button -->
                <div class="close-information">
                    <img @click="toggleBodyScroll(!infoClick)" src="../assets/close.svg"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "InfoHeader",
		props: {
			information: {
				type: String,
				required: true
			},
			isInfoClickedProp: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				isInfoClicked: this.isInfoClickedProp
			};
		},
		methods: {
			toggleBodyScroll: function (value) {
				this.$gtag.event('infoHeaderClick', {
					eventCategory: 'infoHeader',
					eventAction: 'click',
					eventValue: value ? 1 : 0
				})
				this.infoClick = value
				this.$store.commit("toggleBodyScroll", this.infoClick);
			}
		},
		beforeDestroy() {
			this.toggleBodyScroll(false)
		},
		computed: {
			infoClick: {
				set: function (newValue) {

					this.isInfoClicked = newValue;
				},
				get: function () {
					return this.isInfoClicked;
				}
			},
			panelContent: function () {
				return {
					panelContentInactive: !this.isInfoClicked,
					panelContentActive: this.isInfoClicked
				};
			},
			infoArrow: function () {
				return {
					arrowDown: !this.isInfoClicked,
					arrowUp: this.isInfoClicked
				};
			}
		}
	};
</script>

<style lang="scss" src="../styles/infoheader.scss" scoped></style>
